import { fetchOpengraphHandler } from "./EditorHandler";
import AttachmentUrlConverter from "../../../lib/attachment/AttachmentUrlConverter";
import {addPrefix} from "../../../lib/UriUtil"
import {DAUMBLOG, TISTORY} from "../../../../../admin/src/constants/Service";

let editor_map_iframe_url = window.Config.service === TISTORY ? addPrefix('/proxy/plusmapViewer.php') : 'https://spi.maps.daum.net/imap/map_include/map_editor/v3/iframe.html';

const mergeDaumblogContentCssOptions = config => {
  if (window.Config.service === DAUMBLOG) {
    config.push(window.appInfo.daumblogStyleUrl);
  }

  return config;
};

const mergeDaumBlogPlugins = plugins => {
  if (window.Config.service !== DAUMBLOG) {
    return plugins;
  } else {
    return plugins + ' daumblog-converter';
  }
};

export default (options) => {

  return {
    scroll_object: window,
    width: options.width,
    menubar: false,
    statusbar: false,
    browser_spellcheck: false,
    context_position: ['tc-bc', 'cc-cc'],
    scroll_container_id: 'editorContainer',
    codeblock: {
      highlightStyle: "https://t1.daumcdn.net/tistory_admin/lib/highlight.js/styles/atom-one-light.min.css",
      codeTheme: "default",
      languages: [
        {text: 'HTML', value: 'html'},
        {text: 'CSS', value: 'css'},
        {text: 'Javascript', value: 'javascript'},
        {text: 'Python', value: 'python'},
        {text: 'Java', value: 'java'},
        {text: 'C++', value: 'c++'},
        {text: 'Kotlin', value: 'kotlin'},
        {text: 'Swift', value: 'swift'},
        {text: 'PHP', value: 'php'},
        {text: 'Go', value: 'go'},
        {text: 'C#', value: 'cs'},
        {text: 'SQL', value: 'sql'},
        {text: 'Scala', value: 'scala'},
      ]
    },
    resize: false,
    autoresize_min_height: '100vh',
    autoresize_overflow_padding: 10,
    body_class: options.uselessMargin == 1? 'content' : 'content use_p_margin',
    content_css: mergeDaumblogContentCssOptions([
      window.appInfo.fontStyleUrl,
      window.Config.keditor_base_url + '/style/editor-content.css',
      window.Config.keditor_base_url + '/style/editor-mobile-content.css',
      window.Config.keditor_base_url + '/style/tistory/content.css',
      window.appInfo.contentStyleUrl,
    ]),
    theme: 'classic',
    skin: false,
    language: 'ko_KR',
    plugins: mergeDaumBlogPlugins('autoresize codeblock maps newPaste code kCharmap klink kImage imageSlide advlist kTable simpleTable textcolor hr colorpicker fileUpload video kData location colorPalette newOg styleFormat kList hrList moreLess fontSelect grammarCheck tistory-attacher tistory-plugins tistory-mode tistory-replacer'),
    toolbar: 'tistory-attacher styleFormat fontSelect | bold italic underline strikethrough colorPalette backColorPalette | alignleft aligncenter alignright alignjustify | kList simpleTable klink hrList tistory-plugins | tistory-mode',
    font_formats: '기본서체=AppleSDGothicNeo-Regular,"Malgun Gothic","맑은 고딕",dotum,"돋움",sans-serif;본고딕 R="Noto Sans Demilight", "Noto Sans KR";본고딕 L="Noto Sans Light";나눔고딕=Nanum Gothic;본명조="Noto Serif KR";궁서="GungSeo",serif;',
    font_formats_align: 'center',
    preview_styles: 'font-family font-size font-weight font-style text-decoration text-transform color background background-color border border-left border-bottom border-right border-top border-radius outline text-shadow padding',
    CDM_font_match_formats: {
      system: 'AppleSDGothicNeo-Regular, Malgun Gothic, 맑은 고딕, dotum, 돋움, sans-serif',
      notoSans: 'Noto Sans Demilight, Noto Sans KR',
      notoSansLight: 'Noto Sans Light',
      nanumGothic: 'Nanum Gothic',
      nanumBarun: 'Nanum BarunGothic',
      notoSerif: 'Noto Serif KR',
      gungSeo: 'GungSeo, serif',
      kakaoSans: 'KaKao Sans'
    },
    style_formats: [
      {title: '제목1', icon: 'none', block: 'h2', attributes: { 'data-ke-style': '', 'data-ke-size': 'size26' }, styles: { fontSize: '' } },
      {title: '제목2', icon: 'none', block: 'h3', attributes: { 'data-ke-style': '', 'data-ke-size': 'size23' }, styles: { fontSize: '' } },
      {title: '제목3', icon: 'none', block: 'h4', attributes: { 'data-ke-style': '', 'data-ke-size': 'size20' }, styles: { fontSize: '' } },
      {title: '-'},
      {title: '본문1', icon:'none', block: 'p', attributes: { 'data-ke-style': '', 'data-ke-size': 'size18' }, styles: {fontSize: ''}},
      {title: '본문2', icon:'none', block: 'p', attributes: { 'data-ke-style': '', 'data-ke-size': 'size16' }, styles: {fontSize: ''}},
      {title: '본문3', icon:'none', block: 'p', attributes: { 'data-ke-style': '', 'data-ke-size': 'size14' }, styles: {fontSize: ''}},
      {title: '-'},
      {title: '인용1', icon: 'none', block: 'blockquote', attributes: { 'data-ke-style': 'style2' }, styles: {} },
      {title: '인용2', icon: 'none', block: 'blockquote', attributes: { 'data-ke-style': 'style3' }, styles: {} },
    ],
    style_formats_align: 'center',
    convert_urls: false,
    relative_urls: false,
    formats: {
      alignleft: {selector: 'p,h1,h2,h3,h4,h5,h6,td', styles: {textAlign: 'left'}},
      aligncenter: {selector: 'p,h1,h2,h3,h4,h5,h6,td', styles: {textAlign: 'center'}},
      alignright: {selector: 'p,h1,h2,h3,h4,h5,h6,td', styles: {textAlign: 'right'}},
      alignjustify: {selector: 'p,h1,h2,h3,h4,h5,h6,td', styles: {textAlign: 'justify'}},
      bold: {inline: 'b'},
      italic: {inline: 'i'},
      underline: {inline: 'u'},
      strikethrough: {inline: 's'},
      font: {inline: 'span'},
      moreless: {
        block: 'div',
        wrapper: 1,
        remove: 'all',
        attributes: {
          'data-ke-type':'moreLess',
          'data-text-more':'%openText',
          'data-text-less':'%closeText',
        }
      }
    },

    text_inline_elements: 'span strong b em i font s u var cite dfn code mark q sup sub samp',
    valid_children: 'p[s|strike|span|b|u|i|a|#text|br|code|em|sup|sub],-h2[img|div|figure],figcaption[#text],figure[img|figcaption|br|a|div|span|p|iframe],-span[img],+a[div],-li[blockquote|h2|h3]',
    extended_valid_elements: 'b/strong,span/font,font[color],i/em,iframe[mapdata|src|id|width|height|frameborder|scrolling|data-*|allowfullscreen],span[style|class],script[type|src]',
    maps: {
      attach_map_url: `${options.blogManageUrl}/posts/attachMap`,
      map_type: 'full',
      map_url:  ( editor_map_iframe_url ),
      edit_map_url: `${options.blogManageUrl}/posts/attachMap?mode=edit`,
    },
    opengraph: {
      fetch_handler: fetchOpengraphHandler
    },
    kImage: {
      upload_url: `${appInfo.manageUrl}/post/attach.json`,
      is_caption: true,
      is_grid_layout: true,
      toolbar: 'edit resize | widthContent alignLeft alignCenter alignRight floatLeft floatRight representative link',
      representative_image_callback: (data) => options.thumbnailChangeHandler(AttachmentUrlConverter.toTistory(data.src)),
      upload_callback: options.attachmentUploadStatusHandler,
      max_width: 860
    },
    fileUpload: {
      upload_url: `${appInfo.manageUrl}/post/attach.json`,
      delete_url: "/api/delete",
      upload_callback: options.attachmentUploadStatusHandler,
      max_size: 10 * 1024 * 1024,
    },
    video: {
      is_caption: true,
      max_width: 860
    },
    simpleTable: {
      is_grid: true,
      align: 'center'
    },
    kPaste: {
      valid_elements: ['P', 'IMG', 'H1', 'H2', 'H3', 'TABLE', 'TBODY', 'TR', 'TD', 'B', 'S', 'U', 'A', 'I', 'SPAN', 'UL', 'OL', 'LI', 'HR', 'BLOCKQUOTE'],
      extended_valid_elements: { STRONG: 'b', STRIKE: 's', DEL: 's' },
      invalid_table_children: ['TABLE', 'IMG', 'FIGURE', 'PRE', 'HR', 'BLOCKQUOTE'],
      valid_attributes: [
        'href', 'src',
        'rowspan', 'colspan',
        'data-ke-type',
        'data-mce-style',
        'width', 'height',
        'id', 'contenteditable', 'data-+',
        'data-video-vid', 'data-video-thumbnail', 'data-video-url', 'data-video-host', 'data-video-uploader-host',
        'data-maps-data', 'data-ke-style',
      ],
    },
    colorPalette: {
      hilite: true,
      module: ['preset', 'code'], // 'preset', 'palette', 'code'
      color_map_preset: ["", "#000000", "#333333", "#666666", "#9d9d9d", "#dddddd", "#ffffff",
        "#ee2323", "#f89009", "#f3c000", "#009a87", "#006dd7", "#8a3db6", "#7e98b1",
        "#ffc1c8", "#ffc9af", "#f6e199", "#9feec3", "#99cefa", "#c1bef9", "#c0d1e7",
        "#ef5369", "#ef6f53", "#a6bc00", "#409d00", "#0593d3", "#6164c6", "#8cb3be",
        "#781b33", "#953b34", "#5f6d2b", "#1b711d", "#1a5490", "#5733b1", "#456771"],
      preset_rows: 5,
      preset_cols: 7,
      default_color: '#333333',
      black_text_color_background: ['#dddddd', '#ffffff', '#ffc1c8', '#ffc9af', '#f6e199', '#9feec3', '#99cefa', '#c1bef9', '#c0d1e7'],
      align: 'center'
    },
    klink: {
      is_panel: true,
      auto_link: true,
      align: 'center'
    },
    grammarCheck: {
      check_url: `${appInfo.manageUrl}/post/plugins/grammar-check.json`,
      check_node_selector: 'p, h1, h2, h3, h4, h5, h6, ol, ul, blockquote',
      on_start: options.onGrammerCheckStart,
      on_finish: options.onGrammerCheckFinish
    },
    kList: {
      list: [
        {type: 'UL', style: 'disc', icon: 'list-disc', classes:'kList'},
        {type: 'UL', style: 'circle', icon: 'list-circle', classes:'kList'},
        {type: 'OL', style: 'decimal', icon: 'list-decimal', classes:'kList'}
      ],
      align: 'center'
    },
    hrList: [
      {icon: 'hr-style1', attributes: {'data-ke-style': 'style1'}},
      {icon: 'hr-style2', attributes: {'data-ke-style': 'style2'}},
      {icon: 'hr-style3', attributes: {'data-ke-style': 'style3'}},
      {icon: 'hr-style4', attributes: {'data-ke-style': 'style4'}},
      {icon: 'hr-style5', attributes: {'data-ke-style': 'style5'}},
      {icon: 'hr-style6', attributes: {'data-ke-style': 'style6'}},
      {icon: 'hr-style7', attributes: {'data-ke-style': 'style7'}},
      {icon: 'hr-style8', attributes: {'data-ke-style': 'style8'}},
    ],
    hrList_align: 'center',
    editorMode: {
      changeHandler: options.modeChangeHandler
    },
    kCharmap: {
      preview: false,
      items: options.charmapItems
    },
    tistory_plugins: {
      plugins: options.tistoryPlugins,
      open_template_handler: options.openTemplateHandler,
      open_revenue_handler : options.openRevenueHandler
    },
    init_instance_callback: options.onInit
  }
}
